/**
 * Lightweight activity tracker — ships user actions to POST /api/activity
 * via sendBeacon (fire-and-forget, survives page unload).
 */
import { API_BASE_URL, TOKEN_KEY } from '@/api/client'

const ACTIVITY_API = API_BASE_URL + '/api/activity'

function getUserId(): string | null {
  try {
    const token = localStorage.getItem(TOKEN_KEY)
    if (!token) return null
    const parts = token.split('.')
    if (parts.length !== 3) return null
    const payload = JSON.parse(atob(parts[1]))
    return payload.email || payload.userId || null
  } catch { return null }
}

export function trackActivity(action: string, detail?: Record<string, unknown>) {
  try {
    navigator.sendBeacon(ACTIVITY_API, new Blob(
      [JSON.stringify({
        source: 'admin',
        action,
        route: window.location.pathname,
        userId: getUserId(),
        detail,
        ts: new Date().toISOString()
      })],
      { type: 'application/json' }
    ))
  } catch { /* best-effort */ }
}
